import type { IConfigurationContentData } from 'src/types/configuration';
import type { ProjectJsonData } from 'src/types/project';

import { IDecodedCfgFile } from '../types';
import {
  emptyProjectJsonData,
  importTopologyFromCfg,
} from './import-topology-from-cfg';

export const buildProjectJsonData = (
  decodedFiles: IDecodedCfgFile<IConfigurationContentData>[],
): ProjectJsonData => {
  if (!decodedFiles.length) return emptyProjectJsonData();
  return importTopologyFromCfg(decodedFiles);
};
